var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "homepage--template" }, [
    _c(
      "div",
      { staticClass: "home-handle-overflow" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !!_vm.page.landing_section &&
                  !_vm.isWindowWidthMobile &&
                  _vm.page.landing_section.is_bg_video_visible,
                expression:
                  "\n        !!page.landing_section &&\n          !isWindowWidthMobile &&\n          page.landing_section.is_bg_video_visible\n      ",
              },
              {
                name: "lazy",
                rawName: "v-lazy:background",
                value: _vm.page.landing_section.video_bg_image,
                expression: "page.landing_section.video_bg_image",
                arg: "background",
              },
            ],
            staticClass:
              "dn db-ns relative w-100 z-content bg-beige aspect-ratio aspect-ratio--16x9 bg-vid-image",
          },
          [
            _c(
              "h1",
              {
                staticClass: "absolute mv0 tc h1 w1 transparent",
                staticStyle: { color: "transparent" },
              },
              [_vm._v("\n        Outside Lands\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "vimeo-wrapper absolute aspect-ratio aspect-ratio--16x9 bg",
              },
              [
                _c("iframe", {
                  staticClass: "aspect-ratio--object cover",
                  attrs: {
                    src:
                      "https://player.vimeo.com/video/" +
                      _vm.page.landing_section.background_video_vimeo_id +
                      "?background=1&autoplay=1&loop=1&byline=0&title=0",
                    frameborder: "0",
                    webkitallowfullscreen: "",
                    mozallowfullscreen: "",
                    allowfullscreen: "",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "db absolute abs-vert-center left-0 right-0 center mw7",
              },
              [
                _c("simple-svg", {
                  attrs: {
                    filepath:
                      "/assets/images/logos/ol21-logo-lockup-outline.svg",
                    id: "ol20-logo-lockup-yellow",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "db relative w-100 h-auto pv4 pt5-ns pb6-ns z-content bg-beige",
          },
          [
            _c("div", { staticClass: "relative container-fluid" }, [
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isWindowWidthMobile,
                      expression: "isWindowWidthMobile",
                    },
                  ],
                  staticClass:
                    "relative center mw8-4 dn flex-ns flex-column flex-row-ns items-center pb4 pb5-ns",
                },
                [
                  _vm.page.landing_section.cta_button.is_published
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "db relative center mw6 mt4-ns ph4 btn-primary has-red-bg",
                          attrs: {
                            to: _vm.page.landing_section.cta_button.link,
                          },
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.page.landing_section.cta_button.copy
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.page.landing_section.cta_button_2.is_published
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "db relative center mw6 mt5 mt4-ns ph4 btn-primary has-teal-bg",
                          attrs: {
                            to: _vm.page.landing_section.cta_button_2.link,
                          },
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.page.landing_section.cta_button_2.copy
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "db relative mv4 mv5-ns center mw8-4",
                  attrs: { id: _vm.page.about_section.slug },
                },
                [
                  _c("div", {
                    staticClass: "cms-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.marked(_vm.page.about_section.text)
                      ),
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "fixedbg",
          { attrs: { background: _vm.page.fixed_bg_section.image } },
          [
            _c(
              "template",
              { slot: "contents" },
              [
                _c(
                  "accolades-static",
                  [
                    _c("template", { slot: "fixed-bg-contents" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.page.fixed_bg_section.text),
                        },
                      }),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "relative z-content bg-beige pv5" }, [
          _c(
            "section",
            {
              staticClass: "relative center pv4 is-black",
              attrs: { id: "featured_content_carousel" },
            },
            [
              _c("div", {
                staticClass:
                  "swiper-button-prev-home outline-0 absolute h-100 z-6",
                attrs: { slot: "button-prev" },
                slot: "button-prev",
              }),
              _vm._v(" "),
              _c(
                "swiper",
                { ref: "mySwiper", attrs: { options: _vm.swiperOptions } },
                [
                  _vm._l(
                    _vm.featuredContentSlidesFiltered,
                    function (featured, index) {
                      return _c(
                        "swiper-slide",
                        { key: "featured-carousel-item" + index },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "relative slide fl",
                              attrs: {
                                to: featured.link,
                                title: featured.title,
                              },
                            },
                            [
                              _c("div", { staticClass: "db w-100" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "db relative center img-main fl z-2",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: featured.image,
                                        alt: featured.title,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dib relative fl z-2 img-icon",
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "absolute abs-vert-center",
                                      attrs: {
                                        src: featured.icon_image,
                                        alt: featured.title + " Icon",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dib content-info fl relative z-2",
                                  },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f22px is-tablet-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(featured.title) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "f18px is-tablet-regular",
                                      },
                                      [_vm._v(_vm._s(featured.text))]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-pagination swiper-pagination-bullets",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "swiper-button-next-home outline-0 absolute h-100 z-6",
                attrs: { slot: "button-next" },
                slot: "button-next",
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "relative w-100 pt3-ns pb6 flex flex-column bg-beige z-content container-fluid",
          },
          [
            _c(
              "div",
              { staticClass: "relative w-100 mw8-4 center mb3 bg-navy" },
              [
                _c("div", { staticClass: "relative z-4" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "relative row middle-sm" }, [
                    _c(
                      "div",
                      { staticClass: "dn db-ns col-sm-6 ph4 mb4" },
                      [
                        _vm._l(_vm.postsHome, function (post, index) {
                          return _c(
                            "div",
                            {
                              key: "home-news-post-" + index,
                              staticClass: "w-90-ns pr4-ns pv3 pv4-m pv4-l",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "home-news-link",
                                  attrs: { to: post.url },
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "is-beige is-tablet-wide-bold f20px lh-title",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(post.title)
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "dib w1 ml2" },
                                        [
                                          _c("simple-svg", {
                                            staticClass:
                                              "right-arrow is-orange news-right-arrow",
                                            attrs: {
                                              filepath:
                                                "/uploads/checkout-arrow.svg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "db mt3 is-beige is-tablet-regular ttu f15px",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(post.date))
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow mb4",
                            attrs: { title: "news", href: "news" },
                          },
                          [
                            _vm._v(
                              "\n                  View More News Posts \n                  "
                            ),
                            _c("simple-svg", {
                              staticClass: "checkout is-yellow",
                              attrs: {
                                filepath: "/uploads/checkout-arrow.svg",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 pv4 ph4 b-top--beige-xs b-bottom--beige-xs",
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: "/uploads/news-img1.jpg",
                              expression: "'/uploads/news-img1.jpg'",
                            },
                          ],
                          staticClass: "w-100 relative",
                          attrs: { alt: "News image" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dn-ns flex flex-column col-xs-12 mv3 ph4",
                      },
                      [
                        _vm._l(_vm.postsHome, function (post, index) {
                          return _c(
                            "div",
                            {
                              key: "home-news-post-" + index,
                              staticClass: "w-90-ns pr4-ns pv3 pv4-m pv4-l",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "home-news-link",
                                  attrs: { to: post.url },
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "is-beige is-tablet-wide-bold f20px lh-title",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(post.title)
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "dib w1 ml2" },
                                        [
                                          _c("simple-svg", {
                                            staticClass:
                                              "right-arrow is-orange news-right-arrow",
                                            attrs: {
                                              filepath:
                                                "/uploads/checkout-arrow.svg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "db mt3 is-beige is-tablet-regular ttu f15px",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(post.date))
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "f15px is-tablet-bold pb4 lh-20px ttu is-tablet-regular is-yellow",
                            attrs: { title: "news", href: "news" },
                          },
                          [
                            _vm._v(
                              "\n                  View More News Posts \n                  "
                            ),
                            _c("simple-svg", {
                              staticClass: "checkout is-yellow",
                              attrs: {
                                filepath: "/uploads/checkout-arrow.svg",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "dn db-ns absolute left-0 right-0 center w1 h-100 b-vert--beige-ns",
                    }),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "relative z-content bg-beige pv5" }, [
      _c("img", {
        attrs: {
          src: "/uploads/thankyou-2x1.png",
          alt: "thank you for coming",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "relative center pv3 ph4 b-bottom--beige-ns" },
      [
        _c("span", { staticClass: "db relative" }, [
          _c(
            "h2",
            { staticClass: "f64px lh-title is-blenny is-beige pl3-ns" },
            [_vm._v("NEWS")]
          ),
          _vm._v(" "),
          _c("img", {
            staticClass:
              "db dn-ns absolute right-0 bottom-0 nb3 mw-news-icon z--1",
            attrs: {
              src: "/assets/images/bg-icons/ol20-flower-icon-red-flat.svg",
            },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass:
              "dn db-ns absolute left-0 right-0 center bottom-0 pr5 nb5 mw-news-icon",
            attrs: {
              src: "/assets/images/bg-icons/ol20-flower-icon-red-flat.svg",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }